<div class="card">
	<div class="card-header">
		<h1>Pagos Extraordinarios</h1>
	</div>
	<div class="card-body">
		<div class="row">
			<div class="col-sm">
				<h5>Configuración pago</h5>
				<div class="row">
					<div class="col-sm form-group">
						<label for="type" class="form-label">Tipo de pago extra</label>
						<div class="input-group">
							<button class="btn btn-primary"
								(click)="type = (type==0)?1:0; newExtraPayment.paymentType = undefined; newExtraPayment.discounts = 1;">
								<i [ngClass]="type?'fa fa-toggle-off':'fa fa-toggle-on'"></i>
							</button>
							<input type="text" id="type" name="type" class="form-control"
								[value]="type?'Descuento':'Pago'" disabled>
						</div>
					</div>
					<div class="col-sm form-group" *ngIf="type==0">
						<label for="paymentType" class="form-label">Tipo de Pago</label>
						<select name="paymentType" id="paymentType" class="form-select"
							[(ngModel)]="newExtraPayment.paymentType">
							<option value="undefined">Selecciona</option>
							<option value="1">Horas Extra</option>
							<option value="2">Comisiones</option>
							<option value="3">Otras Bonificaciones</option>
							<option value="4">Otros ingresos</option>
						</select>
					</div>
					<div class="col-sm form-group" *ngIf="type==1">
						<label for="paymentType" class="form-label">Tipo de Descuento</label>
						<select name="paymentType" id="paymentType" class="form-select"
							[(ngModel)]="newExtraPayment.paymentType">
							<option value="undefined">Selecciona</option>
							<option value="1">Ausencias</option>
							<option value="2">ISR</option>
							<option value="3">IGSS</option>
							<option value="4">Anticipos</option>
							<option value="5">Préstamos Bancarios</option>
							<option value="6">Demanda Judicial</option>
							<option value="7">Otros Descuentos</option>
						</select>
					</div>
				</div>
				<div class="row">
					<div class="col-sm form-group">
						<label for="amount" class="form-label">Monto</label>
						<input type="number" min="0" name="amount" id="amount" [(ngModel)]="newExtraPayment.amount"
							class="form-control">
					</div>
					<!-- <div class="col-sm form-group" *ngIf="type == 1">
						<label for="discounts" class="form-label">Número de descuentos</label>
						<div class="input-group">
							<input type="number" min="0" disabled name="discounts" id="discounts"
								[(ngModel)]="newExtraPayment.discounts" class="form-control">
							<button [ngClass]="newExtraPayment.recurrent?'btn-primary':'btn-secondary'"
								[tooltip]="newExtraPayment.recurrent?'Desctivar descuento recurrente':'Activar descuento recurrente'"
								class="btn" *ngIf="newExtraPayment?.discounts == 1"
								(click)="newExtraPayment.recurrent = !newExtraPayment.recurrent">
								<i [ngClass]="newExtraPayment.recurrent?'fa fa-toggle-on':'fa fa-toggle-off'"></i>
							</button>
						</div>
					</div> -->
				</div>
				<div class="form-group">
					<label for="description" class="form-label">Descripción</label>
					<textarea name="description" placeholder="Ingresa una descripción" id="description" class="form-control"
						[(ngModel)]="newExtraPayment.description" cols="30" rows="5"></textarea>
				</div>
			</div>
			<div class="col-sm">
				<h5>Empleados beneficiados <i tooltip="Cargar por CSV" class="clickeable fa fa-upload"></i></h5>
				<div class="form-group">
					<label for="filter" class="form-label">
						Filtra
					</label>
					<input type="text" placeholder="Ingresa el nombre o la identificacion" id="filter" (input)="filter($event)" name="filter" class="form-control">
					<p *ngIf="numberContracted > 0" class="form-text"><i class="fa fa-user"></i>Has seleccionado a <b style="font-size: 1.1rem;">{{numberContracted}}</b> empleados
					</p>
				</div>
				<div class="table-responsive mt-2" style="max-height: 250px;">
					<table class="table table-bordered caption-top">
						<thead>
							<tr>
								<th class="td-center">Identificacion</th>
								<th>Nombre</th>
								<td></td>
							</tr>
						</thead>
						<tbody>
							<tr [ngClass]="employee['selected']?'selected-employee':'no-selected-employee'"
								*ngFor="let employee of contractedPersonal">
								<td class="td-center">
									{{employee.identificacion}}
								</td>
								<td>
									{{employee.nombre}}
								</td>
								<td class="td-center">
									<i (click)="employee['selected'] = !employee['selected']; changeNumber()"
										[ngClass]="employee['selected']?'fa fa-circle-check':'fa-regular fa-circle'"></i>
								</td>
							</tr>
							<tr *ngIf="contractedPersonal.length == 0">
								<td colspan="3"><i class="fa fa-circle-info"></i>No existen empleados para el filtro ingresado</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>
	<div class="card-footer">
		<button class="btn btn-success" (click)="saveExtraPayment()" [disabled]="numberContracted==0 || newExtraPayment.amount <= 0 || !newExtraPayment.paymentType || newExtraPayment.paymentType == 'undefined'">
			<i *ngIf="!saving" class="fa fa-save"></i>
			<span *ngIf="saving" class="spinner-border spinner-border-sm"></span>
			GUARDAR
		</button>
	</div>
</div>